import { GameCategoryDto } from "@api-types/games";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { RequestContextType } from "@utils/api-config/RequestContext";
import { createApiRequestOptions } from "@utils/api-config/createApiRequestOptions";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

export class CasinoGameCategoriesApiService {
	static baseUrl = `${CasinoApiAddress}platform/casino-game-categories`;

	static getRequestHeaders = (context: ApiRequestContextData | null) => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async getCategories(
		options = createApiRequestOptions(RequestContextType.Online)
	): Promise<Array<GameCategoryDto>> {
		const context = getApiRequestContext(options);
		return await httpClient.get(
			`${this.baseUrl}/actual-casino-game-categories?translate=true`,
			this.getRequestHeaders(context)
		);
	}
}
